import { DropdownItemProps } from 'semantic-ui-react';

const getSearchableText = (text: DropdownItemProps['text']) => {
  if (typeof text === 'string') {
    return text.toLowerCase();
  }

  if (typeof text === 'number') {
    return text.toString().toLowerCase();
  }

  return '';
};

export const dropdownListSearch = (
  options: DropdownItemProps[],
  query: string,
  minSearchLength = 2
) => {
  if (!query || query.length < minSearchLength) {
    return options;
  }

  const normalizedQuery = query.trim().toLowerCase();
  return options.filter((option) => getSearchableText(option.text).includes(normalizedQuery));
};
